import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors, ScreenDepth } from "@ryde/theme";

export const DotsStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "company-switch-dots",
})`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-inline-end: 7px;
  padding-inline-start: 7px;
  cursor: pointer;

  svg {
    display: block;
  }
`;
export const LangSwitchStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "lang-switch",
})`
  padding-inline-start: 7px;
  padding-inline-end: 7px;
  cursor: pointer;
  position: relative;
`;

export const LangSwitchArea = styled.ul.attrs<IStyledAttributes>({
  "data-e2e": "lang-switch-area",
})`
  position: absolute;
  top: 26px;
  inset-inline-start: 0px;
  background-color: ${rydeColors.smoke};
  border: 1px solid ${greyMui._300};
  width: 57px;
  z-index: ${ScreenDepth.LANG_SWITCH_PANEL};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding-top: 2px;
  padding-inline-start: 6px;
  padding-inline-end: 2px;
  padding-bottom: 2px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  .lang_switch_item {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 35px;

    svg {
      transform-box: fill-box;
      transform-origin: center;
      transition: transform 0.3s ease;
      will-change: transform;
    }

    &:hover svg {
      transform: scale(1.07);
    }
  }
`;
